import { AGENT, DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import FileAttachmentTheme from '../attachments/model/FileAttachmentTheme';
import QuickReplyTheme from '../quick-reply/model/QuickReplyTheme';
import Theme from '../theming/model/Theme';
import { NEUTRAL_700, NEUTRAL_200, NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import { SPOTLIGHT_SPACING_PADDING_PX, SPOTLIGHT_STANDALONE_PADDING_PX, SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX, SPOTLIGHT_VISITOR_CONTENT_PADDING_HORIZONTAL_PX } from '../primary-message/components/messageDimensions';
const fileAttachmentTheme = FileAttachmentTheme({
  tileBackgroundColor: NEUTRAL_200
});
export const buildMessageHistoryTheme = ({
  coloring: {
    accentColor,
    textColor,
    useDefaultColor
  } = {}
}) => ({
  [DEFAULT]: Theme({
    borderRadius: '10px',
    fileAttachmentTheme
  }),
  [AGENT]: Theme({
    borderRadius: '10px',
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? NEUTRAL_1600 : accentColor,
    quickReplyTheme: QuickReplyTheme({
      borderColor: useDefaultColor ? NEUTRAL_700 : accentColor,
      color: useDefaultColor ? NEUTRAL_1600 : textColor
    })
  }),
  [VISITOR]: Theme({
    alignItems: 'flex-end',
    backgroundColor: useDefaultColor ? NEUTRAL_200 : accentColor,
    borderRadius: '10px',
    textColor: useDefaultColor ? NEUTRAL_1600 : textColor,
    fileAttachmentTheme,
    widgetAccent: useDefaultColor ? NEUTRAL_1600 : accentColor
  })
});
export const buildSpotlightMessageHistoryTheme = args => {
  const base = buildMessageHistoryTheme(args);
  return Object.assign({}, base, {
    [AGENT]: Object.assign({}, base[AGENT], {
      backgroundColor: 'transparent',
      contentPadding: '0',
      messageHorizontalPadding: SPOTLIGHT_SPACING_PADDING_PX,
      showAvatar: false,
      showTimestamp: false
    }),
    [DEFAULT]: Object.assign({}, base[DEFAULT], {
      backgroundColor: 'transparent',
      contentPadding: '0',
      messageHorizontalPadding: SPOTLIGHT_SPACING_PADDING_PX,
      showAvatar: false,
      showTimestamp: false
    }),
    [VISITOR]: Object.assign({}, base[VISITOR], {
      backgroundColor: '#F0F0F0',
      borderRadius: '22px',
      contentPadding: `${SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX}px ${SPOTLIGHT_VISITOR_CONTENT_PADDING_HORIZONTAL_PX}px`,
      // Deliberately larger than AGENT/DEFAULT's messageHorizontalPadding:
      // this is what keeps the total gap from the bubble's edge to the
      // widget's outer edge at the intended 24px.
      messageHorizontalPadding: SPOTLIGHT_STANDALONE_PADDING_PX,
      showTimestamp: false,
      textColor: NEUTRAL_1600
    })
  });
};